import {rgElement} from '../rgElement/rg-element.js'

const addPlugins = function(names) {
    let filelist = [];
    for(const name of names) {
        let path = 'https://cdn.regiogate.net/flatpickr/dist/plugins';
        switch(name) {
            case 'confirmDate':
                filelist.push({
                    path: path + '/confirmDate/confirmDate.js',
                    type: 'js',
                    insertPoint: this.shadowRoot
                });
                filelist.push({
                    path: path + '/confirmDate/confirmDate.css',
                    type: 'css',
                    insertPoint: this.shadowRoot
                });
                break;
            case 'labelPlugin':
                filelist.push({
                    path: path + '/labelPlugin/labelPlugin.js',
                    type: 'js',
                    insertPoint: this.shadowRoot
                });
                break;
            case 'monthSelect':
                filelist.push({
                    path: path + '/monthSelect/index.js',
                    type: 'js',
                    insertPoint: this.shadowRoot
                });
                filelist.push({
                    path: path + '/monthSelect/style.css',
                    type: 'css',
                    insertPoint: this.shadowRoot
                });
                break;
            case 'weekSelect':
                filelist.push({
                    path: path + '/weekSelect/weekSelect.js',
                    type: 'js',
                    insertPoint: this.shadowRoot
                });
                break;
            case 'minmaxTimePlugin':
                filelist.push({
                    path: path + '/minmaxTimePlugin.js',
                    type: 'js',
                    insertPoint: this.shadowRoot
                });
                break;
            case 'momentPlugin':
                filelist.push({
                    path: path + '/momentPlugin.js',
                    type: 'js',
                    insertPoint: this.shadowRoot
                });
                break;
            case 'rangePlugin':
                filelist.push({
                    path: path + '/rangePlugin.js',
                    type: 'js',
                    insertPoint: this.shadowRoot
                });
                break;
            case 'scrollPlugin':
                filelist.push({
                    path: path + '/scrollPlugin.js',
                    type: 'js',
                    insertPoint: this.shadowRoot
                });
                break;
        }
    }
    return filelist;
}
const setup = function(datePciker) {
    let plugins = [];
    switch(datePciker.type) {
        case 'week':
            plugins.push(new weekSelect());
            break;
        case 'month':
            plugins.push(new monthSelectPlugin({dateFormat: 'Y-m'}));
            break;
    }
    let enableTime = !!datePciker.dataset.enabletime || datePciker.type === 'datetime-local' || datePciker.type === 'time',
        datePickerConfig = {
            appendTo: datePciker.shadowRoot,
            mode: (datePciker.dataset.mode && [
                'single',
                'multiple',
                'range'
            ].includes(datePciker.dataset.mode)) ? datePciker.dataset.mode : 'single',
            enableTime: enableTime,
            time_24hr: true,
            plugins: plugins,
            weekNumbers: datePciker.type === 'week',
            noCalendar: datePciker.type === 'time',
            showMonths: datePciker.type === 'week' ? 1 : (!!datePciker.dataset.showmonths ? Number(datePciker.dataset.showmonths) : 1),
            disableMobile: true,
            allowInput: true,
            clickOpens: false,
            position: function(instance, customPositionElement) {
                instance.calendarContainer.style.top = '0';
                instance.calendarContainer.style.left = '0';
            }.bind(datePciker),
            onOpen: function(selectedDates, dateStr, instance) {
                let todayButton = instance.calendarContainer.querySelector('.todayButton'),
                    lastSelected = instance.latestSelectedDateObj;
                if(lastSelected) {
                    instance.jumpToDate(lastSelected, false);
                }
                if(!todayButton && datePciker.type !== 'time') {
                    let todayDiv = document.createElement('div'),
                        todayButtonText = datePciker.type === 'week' ? 'Diese Woche' : 'Heute';
                    todayDiv.classList.add('todayButton');
                    todayButton = document.createElement('button');
                    todayButton.innerText = todayButtonText;
                    todayDiv.append(todayButton);
                    instance.calendarContainer.append(todayDiv);
                    todayButton.addEventListener('click', function() {
                        instance.jumpToDate(new Date(), false);
                    })
                }
                datePciker.setAttribute('aria-hidden', 'false');
            }.bind(datePciker),
            onClose: function() {
                datePciker.setAttribute('aria-hidden', 'true');
            }.bind(datePciker),
            onReady: function(selectedDates, dateStr, instance) {
                datePciker.$element.type = datePciker.$element._type;
            }.bind(datePciker)
        }
    if(!validate(datePciker.$element.value, validatorFormatStrings.get(datePciker.type))) {
        let dateObj = Date.parseDateString(datePciker.dataset.value);
        if(isNaN(dateObj)) {
            dateObj = new Date();
        }
        datePciker.$element.setAttribute('value', flatpickr.formatDate(dateObj, datePciker.inputFormat.get(datePciker.type)));
    }
    datePciker.$element.datePicker = flatpickr(datePciker.$element, datePickerConfig);
    if(datePciker.$element.datePicker.hourElement) {
        datePciker.$element.datePicker.hourElement.addEventListener("wheel", handleMouseWheel);
    }
    if(datePciker.$element.datePicker.minuteElement) {
        datePciker.$element.datePicker.minuteElement.addEventListener("wheel", handleMouseWheel);
    }
    setTimeout(function() {
        //Ist das Element in einem Formular und hat "end" im Namen?
        if(datePciker.form && datePciker.$element.name.match('end')) {
            //Passendes Start-Element suchen
            datePciker.dependent = datePciker.form.querySelector('input[name*="' + datePciker.$element.name.replace('end', 'start') + '"]');
            //Wenn gefunden...
            if(datePciker.dependent && datePciker.dependent.datePicker && datePciker.dependent !== datePciker.$element) {
                //MinDate auf das des Start-Elements setzen
                datePciker.$element.datePicker.set('minDate', datePciker.dependent.datePicker.selectedDates[0]);
                //Wenn sich der Wert des Start-Elements ändert...
                datePciker.dependent.datePicker.config.onChange.push(function(selectedDates, dateStr, instance) {
                    let startDate = selectedDates[0],
                        endDate = datePciker.$element.datePicker.selectedDates[0];
                    //Mindate auf den Wert des Start-Elements setzen
                    datePciker.$element.datePicker.set('minDate', startDate);
                    if(startDate > endDate) {
                        //Wenn Start-Datum größer als End-Datum: Werte neu setzen.
                        datePciker.$element.datePicker.set('minDate', startDate);
                        datePciker.$element.datePicker.setDate(startDate);
                    }
                }.bind(datePciker));
            }
        }
    }.bind(datePciker), 500);
}
const validate = function(input, format) {
    const regex = new RegExp(format);
    const result = input.match(regex);
    //TODO: Werte validieren, nicht nur Struktur
    return result !== null;
}
const handleMouseWheel = function(event) {
    event.preventDefault();
    let value = Number(this.value),
        min = Number(this.min),
        max = Number(this.max),
        step = Number(this.step);
    value = event.wheelDeltaY > 0 ? value + step : value - step;
    if(value < min) {
        value = Math.floor(max / step) * step
    } else if(value > max) {
        value = min;
    }
    this.value = value < 10 ? '0' + value : String(value);
    this.select();
    this.focus();
}
const validatorFormatStrings = new Map([
    ['date', '^(\\d{4})-(\\d{2})-(\\d{2})$'],
    ['datetime-local', '^(\\d{4})-(\\d{2})-(\\d{2})T(\\d{2}):(\\d{2})$'],
    ['time', '^(\\d{2}):(\\d{2})$'],
    ['week', '^(\\d{4})-W(\\d{2})$'],
    ['month', '^(\\d{4})-(\\d{2})$']
]);

/**
 * usage: <rg-datetimepicker data-name="ev[start]" data-value="28.02.2023 12:00" data-enabletime="1" data-mode="single" data-showmonths="2"></rg-datetimepicker>
 */
export class rgDatetimepicker extends rgElement {
    $element = null;
    $hiddenElement = null;
    datePicker = null;
    dependent = null;
    outputFormat = new Map([
        ['date', 'd.m.Y'],
        ['datetime-local', 'd.m.Y H:i'],
        ['time', 'H:i'],
        ['week', '\\WW.Y'],
        ['month', 'm.Y']
    ]);
    inputFormat = new Map([
        ['date', 'Y-m-d'],
        ['datetime-local', 'Y-m-dTH:i'],
        ['time', 'H:i'],
        ['week', 'Y-\\WW'],
        ['month', 'Y-m']
    ])

    constructor() {
        super();
    }

    connectedCallback() {
        this.setUpElement();
        this.attachShadow({mode: 'open'});
        this.style.display = 'block';
        //Vorhandenes Element suchen
        if(this.form && this.dataset.name) {
            this.$element = this.form.querySelector('*[name="' + this.dataset.name + '"]');
        } else if(this.dataset.name) {
            this.$element = document.querySelector('*[name="' + this.dataset.name + '"]');
        }
        //Wenn nicht vorhanden: erzeugen.
        if(!this.$element || this.$element.tagName !== 'INPUT') {
            let $input = document.createElement('input');
            if(this.$element && this.$element.tagName !== 'INPUT') {
                this.$element.replaceWith($input);
            } else {
                this.shadowRoot.host.parentElement.insertBefore($input, this.shadowRoot.host);
            }
            this.$element = $input;
        }
        //Element könnte bereits vorhanden sein: umbauen
        this.type = this.dataset.type || 'datetime-local';
        if(![
            'date',
            'datetime-local',
            'time',
            'week',
            'month',
        ].includes(this.type)) {
            this.type = 'datetime-local';
        }
        const urlParams = new URLSearchParams(location.search);
        if(urlParams.has(this.dataset.name)) {
            this.dataset.value = urlParams.get(this.dataset.name);
        }
        const attributes = this.getAttributeNames();
        const ariaAttributes = attributes.filter(name => name.includes('aria'))
        ariaAttributes.forEach(name => {
            this.$element.setAttribute(name, this.getAttribute(name))
        })
        this.$element.setAttribute('type', this.type);
        let dateObj = Date.parseDateString(this.dataset.value);
        this.$element.value = dateObj.format(this.inputFormat.get(this.type));
        this.$element.removeAttribute('name');
        if(this.dataset.required) {
            this.$element.setAttribute('required', 'required');
        }
        //Hidden Element
        //nimmt das Datum im vorgegebenen Format auf
        //das eigentliche Element handled das Datums-Object
        this.$hiddenElement = document.createElement('input');
        this.$hiddenElement.type = "hidden";
        this.$hiddenElement.value = new Date(this.$element.value).format(this.outputFormat.get(this.type));
        this.$hiddenElement.setAttribute('name', this.dataset.name);
        this.shadowRoot.host.parentElement.insertBefore(this.$hiddenElement, this.shadowRoot.host);
        //dem nativen Element Funktionen hinzufügen
        this.$element.setValue = this.setValue.bind(this);
        this.$element.getDate = this.getDate.bind(this);
        this.$element.setOutputFormat = this.setOutputFormat.bind(this);
        //Screenreader-Voodoo
        this.setAttribute('aria-hidden', 'true');
        // NVDA Screenreader wandelt Enter bzw. Space beim Öffnen des Datumswählers mit der Tastatur
        // in einen Click (FF) bzw. Pointerdown+Click (Chrome) um.
        // Der folgende VooDoo sorgt dafür, dass bei Tastaturbedienung immer der native Datumswähler geöffnet wird.
        // Ebenso öffnen echte Touchevents die native Version. Nur Mausklicks öffnen den Flatpickr.
        // echter Mausklick: pressure = 0.5, width = 1
        // echter Touch: pressure > 0, width > 1 (theoretisch auch 1 möglich, aber nie beobachtet → potenzielle Fehlerquelle)
        // programmatisch erzeugtes Event (durch NVDA auf Chrome): pressure = 0, width = 1
        // in FF erzeugt NVDA nur ein click-event,
        // wenn der flatpickr geöffnet wurde verhindert pointerEvent = true, dass ein nachfolgendes click-event zusätzlich den nativen Datepicker öffnet.
        // Mausklicks feuern immer beide events.
        let pointerEvent = false;
        this.$element.addEventListener('change', function(event) {
            const valid = this.$element.checkValidity();
            this.$hiddenElement.value = valid ? new Date(this.$element.value).format(this.outputFormat.get(this.type)) : '';
        }.bind(this));
        this.$element.addEventListener(
            'pointerdown',
            event => {
                if(event.pressure !== 0 && event.width === 1) {
                    pointerEvent = true;
                    event.preventDefault();
                    document.dispatchEvent(new MouseEvent('mousedown'));
                    this.$element.datePicker.open();
                }
            }
        )
        this.$element.addEventListener(
            'click',
            function(event) {
                if(pointerEvent) {
                    event.preventDefault();
                    pointerEvent = false;
                }
            }
        )
        //VooDoo Ende
        this.$element.addEventListener(
            'change',
            event => {
                this.$element.datePicker.setDate(this.$element.value);
            }
        )
        this.$element.addEventListener(
            'keydown',
            event => {
                if(event.code === 'Escape' && this.$element.datePicker.isOpen) {
                    this.$element.datePicker.close();
                }
            }
        )
        let fileList = [
            {
                path: 'https://cdn.regiogate.net/flatpickr/dist/flatpickr' + (!recon.debugmode ? '.min' : '') + '.js',
                type: 'js',
                followup: [
                    {
                        path: 'https://cdn.regiogate.net/flatpickr/dist/l10n/de.js',
                        type: 'js',
                        callback: () => {
                            flatpickr.localize(flatpickr.l10ns.de);
                        }
                    }
                ]
            },
            {
                path: 'https://cdn.regiogate.net/flatpickr/dist/flatpickr.min.css',
                type: 'css',
                insertPoint: this.shadowRoot
            },
            {
                path: 'https://cdn.regiogate.net/flatpickr/dist/themes/airbnb.css',
                type: 'css',
                insertPoint: this.shadowRoot
            },
            {
                path: this.rootpath + '/css/rg-datetimepicker.css',
                type: 'css',
                insertPoint: this.shadowRoot
            },
        ];
        let neededPlugins = [];
        switch(this.type) {
            case 'week':
                neededPlugins.push('weekSelect');
                break;
            case 'month':
                neededPlugins.push('monthSelect');
                break;
        }
        fileList = fileList.concat(addPlugins(neededPlugins));
        this.loadFiles(
            fileList,
            () => {
                setup(this);
            }
        );
        const adoptedCSSTag = document.createElement('style');
        adoptedCSSTag.innerHTML = this.copyStyles('.flatpickr');
        this.shadowRoot.append(adoptedCSSTag);
        this.setupComplete();
    }

    setValue(value) {
        const date = Date.parseDateString(value);
        this.$element.value = date.format(this.inputFormat.get(this.type));
        this.$hiddenElement.value = date.format(this.outputFormat.get(this.type));
    }

    getDate() {
        return new Date(this.$element.value);
    }

    setOutputFormat(format) {
        this.outputFormat.set(this.type, format);
        this.$hiddenElement.value = this.$element.getDate().format(this.outputFormat.get(this.type));
    }
}